import axiosClient from "./axiosClient";

const user = {
  // Lấy danh sách thành viên
  getListUser: async (params) => {
    const url = `/user/paging_search`;
    const response = await axiosClient.get(url, { params: params });
    return response;
  },
  // Thêm thành viên
  addUser: async (data) => {
    const url = `/user/create`;
    const response = await axiosClient.post(url, data);
    return response;
  },
  // Xóa thành viên
  deleteUser: async (params) => {
    const url = `/user/delete`;
    const response = await axiosClient.delete(url, { params: params });
    return response;
  },
  // Thêm thành viên
  updateUser: async (data) => {
    const url = `/user/update`;
    const response = await axiosClient.put(url, data);
    return response;
  },

  //lấy danh sách leader
  getListLeader: async () => {
    const url = `/user/leaders`;
    const response = await axiosClient.get(url);
    return response;
  },
};

export default user;
